import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ItemLocationSetting\UpdateItemLocationSetting::__invoke
* @see app/Http/Controllers/ItemLocationSetting/UpdateItemLocationSetting.php
* @route '/api/item-location-setting/{itemLocationSetting}'
*/
const UpdateItemLocationSetting = (args: { itemLocationSetting: string | number | { id: string | number } } | [itemLocationSetting: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateItemLocationSetting.url(args, options),
    method: 'put',
})

UpdateItemLocationSetting.definition = {
    methods: ["put"],
    url: '/api/item-location-setting/{itemLocationSetting}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ItemLocationSetting\UpdateItemLocationSetting::__invoke
* @see app/Http/Controllers/ItemLocationSetting/UpdateItemLocationSetting.php
* @route '/api/item-location-setting/{itemLocationSetting}'
*/
UpdateItemLocationSetting.url = (args: { itemLocationSetting: string | number | { id: string | number } } | [itemLocationSetting: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { itemLocationSetting: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { itemLocationSetting: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            itemLocationSetting: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        itemLocationSetting: typeof args.itemLocationSetting === 'object'
        ? args.itemLocationSetting.id
        : args.itemLocationSetting,
    }

    return UpdateItemLocationSetting.definition.url
            .replace('{itemLocationSetting}', parsedArgs.itemLocationSetting.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ItemLocationSetting\UpdateItemLocationSetting::__invoke
* @see app/Http/Controllers/ItemLocationSetting/UpdateItemLocationSetting.php
* @route '/api/item-location-setting/{itemLocationSetting}'
*/
UpdateItemLocationSetting.put = (args: { itemLocationSetting: string | number | { id: string | number } } | [itemLocationSetting: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateItemLocationSetting.url(args, options),
    method: 'put',
})

export default UpdateItemLocationSetting